<template>
  <el-dialog :title="isEdit?'编辑公司':'添加公司'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">

    <el-form :model="company" ref="companyFm" label-width="100px" size="small">
      <el-form-item label="公司名称" prop="name" :rules="[{ required: true, message: '请输入公司名称', trigger: 'blur' }]">
        <el-input v-model="company.name" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item label="所属行业">
        <el-select v-model="company.industry" placeholder="请选择所属行业" class='ele_input'>
          <el-option
              v-for="item in industryList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业规模" prop="scale">
        <el-select v-model="company.scale" placeholder="请选择所属行业" class='ele_input'>
          <el-option
              v-for="item in scaleList"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="contact" :rules="[{ required: true, message: '请输入联系人', trigger: 'blur' }]">
        <el-input v-model="company.contact" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
        <el-input v-model="company.phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱" prop="email">
        <el-input v-model="company.email" placeholder="请输入联系邮箱"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input v-model="company.address" placeholder="请输入联系地址"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="submit()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { get, save, update } from '@/api/manage/company'

export default {
  computed: {
    ...mapGetters(['user', 'company']),
    isEdit() {
      return this.echoId
    }
  },
  props: {
    visible: false,
    echoId: null
  },
  data: function() {
    return {
      company: {},
      industryList: [
        {name: '互联网/信息技术',value: 1},
        {name: '制造业', value: 2},
        {name: '贸易/批发/零售',value: 3},
        {name: '房地产业',value: 4},
        {name: '建筑业',value: 5},
        {name: '金融业',value: 6},
        {name: '服务业',value: 7},
        {name: '运输/物流/仓储',value: 8},
        {name: '教育行业',value: 9},
        {name: '文体/娱乐/传媒',value: 10},
        {name: '政府/事业单位',value: 11},
        {name: '公共/环境',value: 12},
        {name: '其他',value: 13}
      ],
      scaleList: ['1-50人', '51-100人', '101-200人', '201-300人', '300人以上'],
    }
  },
  methods: {
    init() {
      if (this.echoId) {
        this.getEcho()
      } else {
        this.company = {}
      }
    },
    getEcho() {
      get(this.echoId).then(resp => {
        this.company = resp.data.result
      })
    },
    doClose() {
      this.$emit('done', false)
    },
    submitCallback(){
      this.$message.success('保存成功')
      this.$emit('done', true)
    },
    submit() {
      this.$refs['companyFm'].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            update(this.company).then(resp => {
              this.submitCallback(resp)
            })
          } else {
            save(this.company).then(resp => {
              this.submitCallback(resp)
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  font-weight: bold;

  &:before {
    content: ' ';
    border-right: 4px solid #4381e6;
    margin-right: 8px;
  }
}
</style>
